import {
    DateDuration,
    endOfMonth,
    getWeeksInMonth,
} from '@internationalized/date';
import { FC } from 'react';
import { useCalendarGrid, useLocale } from 'react-aria';
import { CalendarState } from 'react-stately';
import { CalendarCell } from './CalendarCell';

interface CalendarGridProps {
    state: CalendarState;
    offset?: DateDuration;
}

export const CalendarGrid: FC<CalendarGridProps> = ({ state, offset = {} }) => {
    const { locale } = useLocale();
    const startDate = state.visibleRange.start.add(offset);
    const endDate = endOfMonth(startDate);
    const { gridProps, headerProps, weekDays } = useCalendarGrid(
        {
            startDate,
            endDate,
        },
        state
    );

    // Get the number of weeks in the month so we can render the proper number of rows.
    const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);

    return (
        <table {...gridProps}>
            <thead {...headerProps}>
                <tr>
                    {weekDays.map((day, index) => (
                        <th key={index}>{day}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {Array.from({ length: weeksInMonth }, (_, i) => i).map(
                    (weekIndex) => (
                        <tr key={weekIndex}>
                            {state
                                .getDatesInWeek(weekIndex, startDate)
                                .map((date, i) =>
                                    date ? (
                                        <CalendarCell
                                            key={i}
                                            state={state}
                                            date={date}
                                            currentMonth={startDate}
                                        />
                                    ) : (
                                        <td key={i} />
                                    )
                                )}
                        </tr>
                    )
                )}
            </tbody>
        </table>
    );
};
